import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import complementaryRoadDeleteAction from './complementaryRoadDelete.action.json' with { type: 'json' }
import { complementaryRoadObject } from '../complementaryRoadObject'

const complementaryRoadDeleteDefinition = defineAction({
  ...complementaryRoadDeleteAction,
  input: z.object({
    id: complementaryRoadObject.shape.id,
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default complementaryRoadDeleteDefinition
